// Generated by TranslationPlugin - DO NOT EDIT!!!

import cs from './cs';
import en from './en';
import sk from './sk';

export default {
    cs,
    en,
    sk,
};
